import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import "./style.css";

const AttachmentDetailsPanel = props => {
  const {    
    documentIdInPreview,
    documentIdInPreviewHandler,
    previewDeadlinesHandler,
    isFullscreenOverlay
  } = props;

  const navigate = useNavigate();
  const attachments = useSelector(state =>
    state.deadlinesDetail.subjective.attachments
      ? state.deadlinesDetail.subjective.attachments
      : null);

  const onEyeIconClick = (currentDocId, index) => {
    documentIdInPreviewHandler(currentDocId);
    previewDeadlinesHandler(index);
  };

  const onContainerClick = (currentDocId, index) => {
    documentIdInPreviewHandler(currentDocId);
    previewDeadlinesHandler(index);
  };

  const renderSingleRow = (
    currentDocId,
    currentDescription,
    attachmentNumber,
    attachmentDate,
    index
  ) => {
    return (
      <div
        key={"doc_" + currentDocId}
        className={`attachmentDetailsRow ${
          documentIdInPreview === currentDocId ? "attachmentSelected" : ""
        }`}
        onClick={() => onContainerClick(currentDocId, index)}
      >
        <div style={{ paddingLeft: "16px" }}>
          <FontAwesomeIcon
            style={{
              color: "#152935",
              fontSize: "16px",
              marginRight: "16px"
            }}
            icon={["fal", "file-invoice-dollar"]}
          />
          <span className="attachmentDetailsTitle">
            {attachmentNumber !== undefined &&
              attachmentDate !== undefined &&
              `Fattura ${attachmentNumber.value} del ${attachmentDate.value}`}
            {currentDescription.title}
            {`${currentDescription.details ? currentDescription.details : ""}`}
          </span>
        </div>
        {!isFullscreenOverlay && <div className="attachmentDetailsIconsContainer">
          <FontAwesomeIcon
            style={{
              color: "#0090d1",
              cursor: "pointer",
              fontSize: "16px",
              margin: "0 16px"
            }}
            icon={["far", "eye"]}
            onClick={() => onEyeIconClick(currentDocId, index)}
          />
          <FontAwesomeIcon
            style={{
              color: "#0090d1",
              cursor: "pointer",
              fontSize: "16px",
              margin: "0 16px"
            }}
            icon={["fal", "arrow-right"]}
            onClick={() => {
              navigate("/dettaglio-documento/" + currentDocId);
            }}
          />
        </div>}
      </div>
    );
  };
  return attachments !== null && attachments.length > 0 ? (
    attachments.map((el, index) => {
      const refinedTitle =
        el.document.subTitle !== "" ? el.document.subTitle : el.document.title;
      let counterPart;
      let attachmentNumber;
      let attachmentDate;

      if (el.standardTags !== undefined) {
        counterPart = el.standardTags.find(elem => elem.key === "cessionarioDenominazione");
      }
      if (el.standardTags !== undefined) {
        attachmentNumber = el.standardTags.find(elem => elem.key === "numero");
      }
      if (el.infoList !== undefined) {
        attachmentDate = el.infoList.find(elem => elem.label === "Data documento");
      }
      return renderSingleRow(
        el.id,
        {
          title: refinedTitle,
          details: counterPart
            ? counterPart.value
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
            : ""
        },
        attachmentNumber,
        attachmentDate,
        index
      );
    })
  ) : (
    <div className="attachmentDetailsEmptyContainer">
      <span>
        <FormattedMessage id="deadlines.linkedDocEmpty" />
      </span>
    </div>
  );
};

export default AttachmentDetailsPanel;
